import { FC, PropsWithChildren, ReactNode } from 'react';

import { StyledText } from '@eneco/custom-components/flows/Header';
import { Stack, Heading, Text } from '@eneco/sparky';
import { TextProps } from '@eneco/sparky/types';

import { STEP_TITLE_ID } from '../../utils/focusFlowStepHeading';

interface Props {
  align?: TextProps['align'];
  id?: string;
}

interface CompoundHeaderProps {
  Title: typeof HeaderTitle;
  Text: typeof HeaderText;
}

const HeaderTitle: FC<PropsWithChildren<{ id?: string }>> = ({ children, id = STEP_TITLE_ID }) => (
  <Heading as="h1" id={id} size={{ initial: 'M', md: 'L', lg: 'XL' }}>
    {children}
  </Heading>
);

const HeaderText: FC<{ children: ReactNode; as?: TextProps['as'] }> = ({ children, as = 'p' }) => (
  <Text as={as} size={{ initial: 'BodyM', lg: 'BodyL' }}>
    {children}
  </Text>
);

export const Header: FC<PropsWithChildren<Props>> & CompoundHeaderProps = ({ id, align = 'left', children }) => (
  <StyledText id={id} align={align}>
    <Stack direction="column" gap={{ initial: '2', md: '4' }}>
      {children}
    </Stack>
  </StyledText>
);

Header.Title = HeaderTitle;
Header.Text = HeaderText;
